
import { useGetCollectorDocumentsQuery, useLazyViewCollectorFileQuery } from "../collector";
import { useParams } from "react-router-dom";
import CommonDocumentsGrid from "../../../../components/common/DocumentsGrid/CommonDocumentsGrid";
import DocumentUploadSection from "../../../order/modal/UploadDocumentModal";
import { useState } from "react";
import MultiSelectDocModal from "../../../../components/common/DocumentsGrid/Modal/MultiSelectDocModal";
import { useCreateFileJobMutation } from "../collector";
import SelectYearModal from "../modal/SelectYearModal";

const CollectorDocumentsForm = () => {

  const { collectorId } = useParams();
  const [viewFile] = useLazyViewCollectorFileQuery();
  const [showUploadDocModal, setShowUploadDocModal] = useState(false);
  const [showMultiDocSelectModal, setShowMultiDocSelectModal] = useState(false);
  const [showYearSelectModal, setShowYearSelectModal] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);



  const [createFileJob] = useCreateFileJobMutation();

  const {
    data: documentsData,
  } = useGetCollectorDocumentsQuery(collectorId || "", {

  });

  const handleViewDownloadFile = async ({ id, shouldOpen, fileSize, filename }: {
    id: string;
    shouldOpen: boolean;
    fileSize: any
    filename: string
  }) => {
    viewFile({ fileId: id, isDownload: shouldOpen, fileSize: fileSize, fileName: filename });
  };
  const createJob = async (e: any, selectedYear: string) => {
    setIsLoading(true);
    try {
      await createFileJob({
        collectorId,
        fileId: selectedDocId,
        jobType: "MAP_IMPORT",
        year: selectedYear,
      }).unwrap();
    } catch (error: any) {
      console.error("Error creating job:", error);
    }
    finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <CommonDocumentsGrid
        data={documentsData}
        title="Collector Documents "
        count={documentsData?.length || 0}
        hasAddPermission={true}
        hasSortPermission={true}
        companyId={collectorId}
        onClick={handleViewDownloadFile}
        setShowUploadDocModal={setShowUploadDocModal}
        setShowMultiDocSelectModal={setShowMultiDocSelectModal}
        addPermission={'COLFIL-C'}
        setShowYearSelectModal={setShowYearSelectModal}
        setSelectedDocId={setSelectedDocId}
      />
      {showUploadDocModal &&
        <DocumentUploadSection show={showUploadDocModal} setShow={setShowUploadDocModal}
          relationalId={collectorId} EnumType={"DataFileType"}
          tgxFileType={"COLLECTOR_FILE"} fileDataTypeDefault={"OTHER"}
        />}
      {showYearSelectModal &&
          <SelectYearModal
              show={showYearSelectModal}
              setShow={setShowYearSelectModal}
              title="Select Tax Year"
              onSubmit={createJob}
              isLoading={isLoading}
          />
      }

      {
        showMultiDocSelectModal && (
          <MultiSelectDocModal show={showMultiDocSelectModal}
            setShow={setShowMultiDocSelectModal}

          />
        )
      }

    </>
  );
};


export default CollectorDocumentsForm;
